import React, { useState } from "react";
import { base44 } from "@/api/base44Client";
import { Button } from "@/components/ui/button";
import { RotateCcw } from "lucide-react";

export default function DeletedRunRestoreBar({ entry, onRestored, onDismiss }) {
  const [restoring, setRestoring] = useState(false);

  const handleRestore = async () => {
    setRestoring(true);
    try {
      const { id, ...payload } = entry.run;
      delete payload.created_date;
      delete payload.updated_date;
      delete payload.created_by_id;
      await base44.entities.DrillRun.create(payload);
      onDismiss?.(entry.id);
      onRestored?.();
    } catch (e) {
      console.error(e);
    } finally {
      setRestoring(false);
    }
  };

  const isRun = entry.run?.record_type !== "chip_section";

  return (
    <div className="mb-4 rounded-xl border border-amber-300 bg-amber-50 px-4 py-3 flex items-center justify-between gap-3 dark:border-amber-900 dark:bg-amber-950/40">
      <div className="min-w-0">
        <p className="text-sm font-medium text-amber-800 dark:text-amber-300">
          {isRun ? "Run" : "Chip section"} deleted
        </p>
        <p className="text-xs text-amber-700/80 dark:text-amber-400/80">
          Restore it back onto this sheet.
        </p>
      </div>
      <div className="flex items-center gap-2 shrink-0">
        <Button
          size="sm"
          variant="ghost"
          onClick={() => onDismiss?.(entry.id)}
          disabled={restoring}
          className="rounded-xl text-amber-700 hover:bg-amber-100 dark:text-amber-300 dark:hover:bg-amber-900/40"
        >
          Dismiss
        </Button>
        <Button
          size="sm"
          onClick={handleRestore}
          disabled={restoring}
          className="rounded-xl gap-1.5 bg-amber-600 hover:bg-amber-700 text-white"
        >
          <RotateCcw className="w-3.5 h-3.5" /> Restore
        </Button>
      </div>
    </div>
  );
}